<template>
  <div class="tab-bar-item" @click="itemLink">
    <li>
      <a :class="{ active: isActive }">
        <slot name="item-text"></slot>
      </a>
    </li>
  </div>
</template>

<script>
export default {
  name: "HeaderTabItem",
  props: {
    path: String,
    activeStyle: {
      type: String,
      default: "#0066c8",
    },
  },
  data() {
    return {
      routerPath:
        "/workflow/todo|/workflow/flow_cc|/workflow/doing|/workflow/done|/workflow/apply",
    };
  },
  computed: {
    isActive() {
      if (this.path == "/workflow/todo") {
        if (this.routerPath.indexOf(this.$route.path) !== -1) {
          return true;
        }
      } else {
        return this.$route.path.indexOf(this.path) !== -1;
      }
    },
    activeColor() {
      return this.isActive ? { color: this.activeStyle } : {};
    },
  },
  methods: {
    itemLink() {
      this.$router.push(this.path);
    },
  },
};
</script>

<style scope>
.tab-bar-item {
  flex: 1;
  text-align: center;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/modules/HeaderTabItem.vue